import React from 'react'

function Dashboard() {
  return (
    <div>
      <div className=' h-screen'>
       <h1 className='mt-10'>Welcome To Dashboard </h1>
      </div>
    </div>
  )
}

export default Dashboard